// extracted by mini-css-extract-plugin
export default {"mainContainer":"Layout_mainContainer__rDoUE","headerContainer":"Layout_headerContainer__rpj9E"};